import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";
import { profile } from "../data";

export default function Navbar() {
  return (
    <header className="sticky top-0 z-20 border-b border-fuchsia-500/20 bg-slate-950/85 backdrop-blur">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between px-4 py-4 md:flex-row sm:px-6 lg:px-8">
        <a href="#about" className="bg-gradient-to-r from-pink-400 via-fuchsia-400 to-cyan-300 bg-clip-text text-lg font-bold tracking-wide text-transparent">
          {profile.name}
        </a>
        <nav className="my-3 flex flex-wrap items-center justify-center text-sm text-slate-300 md:my-0 md:text-base">
          <a href="#resume" className="mr-5 hover:text-fuchsia-300">
            Resume
          </a>
          <a href="#case-studies" className="mr-5 hover:text-violet-300">
            Case Studies
          </a>
          <a href="#live-projects" className="mr-5 hover:text-emerald-300">
            Live Projects
          </a>
          <a href="#projects" className="mr-5 hover:text-cyan-300">
            Experience
          </a>
          <a href="#skills" className="mr-5 hover:text-emerald-300">
            Skills
          </a>
          <a href="#education" className="mr-5 hover:text-amber-300">
            Education
          </a>
          <a href={profile.linkedin} target="_blank" rel="noreferrer" className="mr-5 hover:text-pink-300">
            LinkedIn
          </a>
        </nav>
        <a
          href={profile.resumeTextUrl}
          download
          className="inline-flex items-center rounded-md border border-fuchsia-400/40 bg-gradient-to-r from-pink-500/20 to-cyan-500/20 px-4 py-2 text-sm font-medium text-white hover:from-pink-500/30 hover:to-cyan-500/30 md:text-base">
          Download Resume
          <ArrowRightIcon className="w-4 h-4 ml-1" />
        </a>
      </div>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js